import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom-v5-compat'

import { usePostComposer } from '~publish/hooks/usePostComposer'
import { useQueryParam } from '~publish/hooks/useQueryParam'

import { useOnPostComposerClose } from './helpers'

export function PostCreationDialog(): JSX.Element | null {
  const { id: channelId = 'all' } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const { createNewPostInComposer } = usePostComposer()
  const [text = undefined] = useQueryParam<string>('text')

  useEffect(() => {
    void createNewPostInComposer({
      channels: channelId === 'all' ? channelId : [channelId],
      prefillPostData: { text },
    })
  }, [channelId, createNewPostInComposer, text])

  useOnPostComposerClose(() => {
    navigate('..')
  })

  return null
}
